import project1 from '../Assets/Projectsimage/project1.png'
import kashmir from '../Assets/Projectsimage/kashmir.png'
import proj1 from '../Assets/Projectsimage/proj1.png'
import proj2 from '../Assets/Projectsimage/proj2.png'
import proj3 from '../Assets/Projectsimage/proj3.png'
import proj4 from '../Assets/Projectsimage/proj4.png'
import proj5 from '../Assets/Projectsimage/proj5.png'
import livesound from "../Assets/Projectsimage/livesound.png"
import sports from '../Assets/Projectsimage/sports.png'
export const projects = [
  {
    id: 1,
    pimage:livesound,
    date:"01-01-2025",
    title: "Live Sound Trading Company",
    description: "Empowering Innovation Across Industries",
    language: "Next JS REST API's",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://www.livesoundksa.com/'
  },
  {
    id: 2,
    pimage:proj1,
    date:"08-08-2024",
    title: "Woodup Interior Design",
    description: "WoodUp is web app developed for interior design",
    language: "Next JS",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://www.woodup.in/'
  },
  {
    id: 3,
    pimage:proj2,
    date:"08-08-2024",
    title: "Water treatment project",
    description: "Chemical Oxygen Demand (COD) and (BOD) Prediction",
    language: "Flask and Nextjs",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://watertreatmentbymj.vercel.app/analyze'
  },
  {
    id: 4,
    pimage:proj3,
    date:"08-11-2024",
    title: "Employee Manager and Task Manager",
    description: "Complete Employee manager and task manager Full stack",
    language: "Next 15",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://mjmsfullstack.vercel.app/'
  },
  {
    id: 5,
    pimage:proj4,
    date:"08-08-2022",
    title: "Noorul Harmain Travel app",
    description: "Travel app for Umrah Services",
    language: "NEXT JS 15",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://noorulharmain.vercel.app/'
  },
  {
    id: 6,
    pimage:proj5,
    date:"12-12-2024",
    title: "Secure key generation",
    description: "AES based key generation for successful payment",
    language: "FLASK",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://flask-appmj.onrender.com/'
  },
  {
    id: 7,
    pimage:project1,
    date:"08-08-2022",
    title: "Student Grading System",
    description: "Complete Student analysis gradebook with graphs and visualisation",
    language: "REACT JS",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://gradebookmjm.netlify.app/'
  },
  
  {
    id: 8,
    pimage:kashmir,
    date:"08-08-2015",
    title: "Beauty of Kashmir WebSite",
    description: "Designed Web Application on Beauty of kashmir using HTML CSS and JS",
    language: "HTML CSS JS",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:''
  },
   {
    id: 9,
    pimage:sports,
    date:"Dec 2025",
    title: "Sports city ",
    description: "Next js app for sports complex",
    language: "next js",
    linkgithub: 'https://github.com/Mir-Junaid-Rasool',
    linklive:'https://sportscity.vercel.app/'
  }
]
  
